import { CheckCircleIcon, ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { IEbayListingBatchItem } from "../../../models/bulkListings/BulkListing";
import PopOutBox from "../../shared/PopOutBox";
import RecentlyListedTypeCell from "./RecentlyListedTypeCell";
import UnlistedReadyStatus from "../unlistedTable/UnlistedReadyStatus";


export default function RecentlyListedErrorCell({ batchItem }: { batchItem: IEbayListingBatchItem }) {


  if (!batchItem.errorMessage) {
    return (
      <div className="flex flex-col gap-y-4 items-center justify-center">
        <CheckCircleIcon className="h-6 w-6 text-green-500" />
        <RecentlyListedTypeCell type={batchItem.type} />
      </div>
    )
  }

  return (
    <div className="flex flex-col gap-y-4 items-center justify-center">
      <PopOutBox
        position="left"
        classes="max-w-3xl max-w-[60vw] max-h-[50vh] overflow-y-auto"
        icon={batchItem.isListed ? <ExclamationTriangleIcon className="h-6 w-6 text-yellow-500" /> : <ExclamationTriangleIcon className="h-6 w-6 text-red-500" />}
      >
        <div className="p-2">
          <p className="text-sm font-medium mb-2">eBay Error:</p>
          <pre>{batchItem.errorMessage}</pre>
        </div>
      </PopOutBox>
      <RecentlyListedTypeCell type={batchItem.type} />
      {!batchItem.isListed && <UnlistedReadyStatus part={batchItem.partData} />}
    </div>
  )
}